import { useEffect, useRef, useState } from "react";
import { ChevronDown, KeyRound, LogOut } from "lucide-react";
import { Link } from "react-router-dom";

export default function UserMenu({ user, onLogout }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const handlePointerDown = (event) => {
      if (!containerRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open]);

  const displayName = user?.full_name || user?.username || "";
  const initial = displayName.trim().charAt(0) || "؟";

  return (
    <div className={`user-menu${open ? " open" : ""}`} ref={containerRef}>
      <button
        type="button"
        className="user-trigger"
        onClick={() => setOpen((value) => !value)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <span className="avatar" aria-hidden="true">
          {initial}
        </span>
        <span className="who">
          <strong>{displayName}</strong>
          {/* The username, not the role — a display name of «مدیر سیستم» would repeat it. */}
          <span className="who-username">{user?.username}</span>
        </span>
        <ChevronDown className="user-chevron" size={16} strokeWidth={2.2} aria-hidden="true" />
      </button>

      {open && (
        <div className="user-dropdown" role="menu">
          <div className="user-dropdown-head">
            <span className="avatar avatar-lg" aria-hidden="true">
              {initial}
            </span>
            <div>
              <strong>{displayName}</strong>
              <span>{user?.is_admin ? "مدیر سیستم" : "کاربر"}</span>
            </div>
          </div>

          <Link
            to="/dashboard/settings/password"
            className="user-dropdown-item"
            role="menuitem"
            onClick={() => setOpen(false)}
          >
            <KeyRound size={17} strokeWidth={1.9} aria-hidden="true" />
            تغییر رمز عبور
          </Link>

          <button type="button" className="user-dropdown-item danger" role="menuitem" onClick={onLogout}>
            <LogOut size={17} strokeWidth={1.9} aria-hidden="true" />
            خروج از حساب
          </button>
        </div>
      )}
    </div>
  );
}
